export default __webpack_public_path__ + "static/media/portfoliopic.d9065930.jpeg";